import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { languages } from '@shared/i18n/languages';
import { LanguageService } from '@shared/tools/language.service';
import { Subscription } from 'rxjs';
import { ModalService } from '@shared/components/modal-list/modal-list.service';

@Component({
  selector: 'app-languages-dialog',
  imports: [CommonModule, TranslateModule],
  templateUrl: './languages-dialog.component.html',
  styleUrl: './languages-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguagesDialogComponent implements OnInit, OnDestroy {
  languages = languages;
  currentLanguage = this.languageService.currentLanguage();
  subscription = new Subscription();

  constructor(
    private languageService: LanguageService,
    private modalService: ModalService,
    private tranlationService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.populate();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  populate() {
    this.subscription.add(
      this.tranlationService.get('language-dialog.title').subscribe(title => {
        this.modalService.updateTitle('modal-language', title);
      }),
    );
  }

  handlerChangeLanguage(event: any) {
    const value = event.currentTarget?.value;
    this.languageService.setLanguage(value);
  }

  close() {
    this.modalService.close();
  }
}
